import script from "./CountryVSRegionComparison.vue?vue&type=script&setup=true&lang=js"
export * from "./CountryVSRegionComparison.vue?vue&type=script&setup=true&lang=js"

import "./CountryVSRegionComparison.vue?vue&type=style&index=0&id=49202550&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49202550"]])

export default __exports__